import {
  ADD_SEARCH_STRING,
  CHANGE_SEARCH_FILTER,
  CLEAR_PDF_FILE,
  HIDE_LEFT_BAR,
  HIDE_RIGHT_BAR,
  IS_SHOW_SEARCH_DETAILS,
  REQUEST_PDF,
  REQUEST_PDF_FAILED,
  REQUEST_PDF_SUCCESS,
  REQUEST_RUBRIC,
  REQUEST_RUBRIC_FAILED,
  REQUEST_RUBRIC_SUCCESS,
  REQUEST_SEARCH_DETAILS_RESULTS,
  REQUEST_SEARCH_DETAILS_RESULTS_FAILED,
  REQUEST_SEARCH_DETAILS_RESULTS_SUCCESS,
  REQUEST_SEARCH_RESULTS,
  REQUEST_SEARCH_RESULTS_FAILED,
  REQUEST_SEARCH_RESULTS_SUCCESS,
  REQUEST_TYPE_SUCCESS,
  SET_SEARCH_VALUE,
} from '../constants';
import { createActions } from 'redux-actions';

export const {
  toggleSearchActive,
  toggleSearchSettings,
  isShowSearchDetails,
  hideLeftBar,
  hideRightBar,
  setSearchValue,
  requestSearchResults,
  requestSearchResultsSuccess,
  requestSearchResultsFailed,
  requestRubric,
  requestRubricSuccess,
  requestRubricFailed,
  requestTypeSuccess,
  requestSearchDetails,
  requestSearchDetailsSuccess,
  requestSearchDetailsFailed,
  requestPdf,
  requestPdfSuccess,
  requestPdfFailed,
  addSearchString,
  clearPdfFile,
  changeSearchFilter,
} = createActions(
  IS_SHOW_SEARCH_DETAILS,
  HIDE_LEFT_BAR,
  HIDE_RIGHT_BAR,
  SET_SEARCH_VALUE,
  REQUEST_SEARCH_RESULTS,
  REQUEST_SEARCH_RESULTS_SUCCESS,
  REQUEST_SEARCH_RESULTS_FAILED,
  REQUEST_RUBRIC,
  REQUEST_RUBRIC_SUCCESS,
  REQUEST_RUBRIC_FAILED,
  REQUEST_TYPE_SUCCESS,
  REQUEST_SEARCH_DETAILS_RESULTS,
  REQUEST_SEARCH_DETAILS_RESULTS_SUCCESS,
  REQUEST_SEARCH_DETAILS_RESULTS_FAILED,
  REQUEST_PDF,
  REQUEST_PDF_SUCCESS,
  REQUEST_PDF_FAILED,
  ADD_SEARCH_STRING,
  CLEAR_PDF_FILE,
  CHANGE_SEARCH_FILTER
);
